/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable prefer-template */
/* eslint-disable brace-style */
import React, {
  useState, useContext, useEffect, useRef
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import { Input, VoucherList, Icon, Button, Typography, Divider } from '@telus/koodo-ui-kit'
import AccountHelpers, { VOUCHER_STATE } from '@apps/flows/activation/services/accountHelper'
import { getPromoNames } from '@apps/utils/common'
import {
  PAYMENT_STATE,
  updatePaymentStates
} from '@apps/redux/features/PayAndReviewSlice'
import { currencyFormatter } from '@apps/utils/CurrencyFormatter'
import { ANALYTICS_EVENT_TYPES } from '@apps/utils/constants'
import { setPageAnalytics } from '@apps/utils/Analytics'
import CreditCardSection from './CreditCardSection'
import useTagManagerInfo from '../../../_engine/hooks/useTagManagerInfo'

const VoucherOptionSection = ({
  showErrors, handleSIMActivation, textContent, setButtonIsLoading
}) => {
  const [voucherCode, setVoucherCode] = useState('')
  const [voucherCodeErrorMessage, setVoucherCodeErrorMessage] = useState('')
  const [isVoucherLoading, setIsVoucherLoading] = useState(false)
  const [isListExpanded, setIsListExpanded] = useState(true)
  const dispatch = useDispatch()
  const [autoTopUps, setAutoTopUps] = useState(true)
  const location = useLocation()

  const {
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.CURRENT_LANGUAGE]: currentLanguage,
    [APPLICATION_STATE.CURRENT_REGION]: region
  } = useContext(ApplicationContext)

  const paymentState = useSelector((state) => state.payAndReviewPage)
  const voucherRequiredRef = useRef(null)
  const voucherButtonRef = useRef(null)

  const updatePaymentStore = (payload) => {
    dispatch(updatePaymentStates(payload))
  }

  const {
    [PAYMENT_STATE.VOUCHER.ADDED_VOUCHERS]: addedVouchers,
    [PAYMENT_STATE.AUTO_TOP_UPS]: isRegisterTopupEnabled,
    [PAYMENT_STATE.VOUCHER.INSUFFICIENT_AMOUNT_ERROR]: hasInsufficientVoucherCodeError,
    [PAYMENT_STATE.PAYMENT_GATEWAY]: paymentGateway,
    [PAYMENT_STATE.SUMMARY.AMOUNT_DUE]: amountDue,
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: isMultiPromoLoading,
    [PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: triggerValidation,
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: multiPromotionCodeInfo
  } = paymentState

  const voucherTotal = addedVouchers.reduce((acc, curr) => acc + Number(curr.totalAmount), 0)

  const { voucherInfo } = brandServices

  const mounted = useRef(false)
  useEffect(() => {

    if (mounted.current && voucherCode?.length !== 0) {
      validateVoucherCode()
      addVoucherCode()
    } else {
      mounted.current = true
    }

    if (voucherCode?.length === 0) {
      setVoucherCodeErrorMessage('')
    }

    if (mounted.current && voucherCode?.length === 0 && voucherCodeErrorMessage !== '') {
      validateVoucherCode()
      addVoucherCode()
    } else {
      mounted.current = true
    }
  }, [validateVoucherCode, addVoucherCode])

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      return
    }

    if (!voucherCodeErrorMessage) return

    if (voucherCode?.length > 0) {
      validateVoucherOptionLanguageChange()
    } else {
      setVoucherCodeErrorMessage('')

      if (voucherCodeErrorMessage !== '') {
        validateVoucherOptionLanguageChange()
      }
    }
  }, [currentLanguage])

  const tagManagerInfo = useTagManagerInfo()

  // eslint-disable-next-line camelcase
  const pushClickAnalytics = ({ click_text, promoCodeDescription, event_type, automatic_top_up, target_link, field_warning, error_response_code, event_click = ANALYTICS_EVENT_TYPES.CLICK } = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, currentLanguage, {
        ...tagManagerInfo,
        click_text,
        field_warning,
        error_response_code,
        automatic_top_up,
        promoCodeDescription
      }, event_type, event_click, target_link)
    )
  }

  const handleVoucherCodeChange = (value) => {
    if (/^[a-zA-Z0-9]*$/.test(value)) {
      setVoucherCode(value)
    }
    if (voucherCodeErrorMessage !== '') setVoucherCodeErrorMessage('')
  }

  const validateVoucherCode = () => {
    if (voucherCode.length === 0) {
      setVoucherCodeErrorMessage(textContent?.shortTextFields?.voucherCodeRequired)
    } else if (voucherCode.length < 12) {
      setVoucherCodeErrorMessage(textContent?.shortTextFields?.voucherCodeInvalid)
    }
  }
  const removePromo = (item) => {
    pushClickAnalytics({ click_text: 'close icon - remove voucher', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'remove voucher onclick of close icon' })
    const filtered = addedVouchers.filter((voucher) => voucher.id !== item.id)
    updatePaymentStore({ [PAYMENT_STATE.VOUCHER.ADDED_VOUCHERS]: filtered })
  }

  const addVoucherCode = async () => {
    // Move focus off the Add button so it doesn't stay focused after the
    // voucher is added and the button leaves its loading state.
    if (voucherButtonRef.current) {
      voucherButtonRef.current.blur()
    }
    validateVoucherCode()
    if (voucherCode && voucherCode.length === 12) {
      pushClickAnalytics(textContent?.shortTextFields?.add)
      const existingVoucher = addedVouchers.find((voucher) => voucher.id === voucherCode)
      if (!existingVoucher) {
        setIsVoucherLoading(true)
        const voucherResp = await AccountHelpers.executeVoucherInfo(voucherInfo, voucherCode)
        if (voucherResp && !voucherResp.error) {
          const voucherArr = Array.from(addedVouchers)
          voucherArr.push(voucherResp)
          updatePaymentStore({ [PAYMENT_STATE.VOUCHER.ADDED_VOUCHERS]: voucherArr })
          // dispatch(setPaymentInformation({
          //   ...paymentInfo,
          //   addedVouchers: [...paymentInfo?.addedVouchers, voucherCode]
          // }))
          setVoucherCode('')
          pushClickAnalytics({ click_text: textContent?.shortTextFields?.add + 'voucher', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Voucher code added successfully' })

        } else {
          let voucherError = textContent?.shortTextFields?.voucherCodeInvalid
          if (voucherResp && voucherResp.error === VOUCHER_STATE.USED) {
            voucherError = textContent?.shortTextFields?.voucherCodeUsed
          }
          setIsVoucherLoading(false)
          setVoucherCodeErrorMessage(voucherError)
          pushClickAnalytics({ click_text: 'Voucher code already used', field_warning: voucherError, error_response_code: '500', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Voucher code already used or invalid' })

          return false
        }
        setIsVoucherLoading(false)
        return true
      }
      setVoucherCodeErrorMessage(textContent?.shortTextFields?.voucherCodeUsed)
    }
    return false
  }

  const validateVoucherOptionLanguageChange = async () => {
    validateVoucherCode()
    if (voucherCode && voucherCode.length === 12) {
      const existingVoucher = addedVouchers.find((voucher) => voucher.id === voucherCode)
      if (!existingVoucher) {
        setIsVoucherLoading(true)
        const voucherResp = await AccountHelpers.executeVoucherInfo(voucherInfo, voucherCode)
        if (voucherResp && !voucherResp.error) {
          const voucherArr = Array.from(addedVouchers)
          voucherArr.push(voucherResp)
        } else {
          let voucherError = textContent?.shortTextFields?.voucherCodeInvalid
          if (voucherResp && voucherResp.error === VOUCHER_STATE.USED) {
            voucherError = textContent?.shortTextFields?.voucherCodeUsed
          }
          setIsVoucherLoading(false)
          setVoucherCodeErrorMessage(voucherError)
          return false
        }
        setIsVoucherLoading(false)
        return true
      }
      setVoucherCodeErrorMessage(textContent?.shortTextFields?.voucherCodeUsed)
    }
    return false
  }

  const handleRegisterPopup = () => {
    if (autoTopUps) {
      pushClickAnalytics({ click_text: textContent?.shortTextFields?.voucherMessageHeading + 'unchecked', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Automatic top up unchecked', automatic_top_up: 'unchecked' })
    }
    else {
      pushClickAnalytics({ click_text: textContent?.shortTextFields?.voucherMessageHeading + 'checked', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Automatic top up checked', automatic_top_up: 'checked' })
    }
    updatePaymentStore({ [PAYMENT_STATE.AUTO_TOP_UPS]: !isRegisterTopupEnabled })
    setAutoTopUps(!autoTopUps)
    // dispatch(setPaymentInformation({
    //   ...paymentInfo,
    //   autoTopUps
    // }))
  }

  useEffect(() => {
    updatePaymentStore({ [PAYMENT_STATE.VOUCHER.INSUFFICIENT_AMOUNT_ERROR]: (addedVouchers.length <= 0 || (addedVouchers.length > 0 && amountDue > 0)) })
    updatePaymentStore({ [PAYMENT_STATE.TRIGGER_EPS_CARD_VALIDATION]: false })
    if ((addedVouchers && addedVouchers.length > 0) && (hasInsufficientVoucherCodeError || (Number(amountDue) > 0))) {
      voucherRequiredRef.current.scrollIntoView({
        behavior: "smooth"
      })
    }
    if ((showErrors && addedVouchers && addedVouchers.length === 0)) {
      setVoucherCodeErrorMessage(textContent?.shortTextFields?.voucherCodeRequired)
      voucherRequiredRef.current.scrollIntoView({
        behavior: "smooth"
      })
    }
  }, [hasInsufficientVoucherCodeError, amountDue])

  useEffect(() => {
    if ((showErrors && addedVouchers && addedVouchers.length === 0)) {
      setVoucherCodeErrorMessage(textContent?.shortTextFields?.voucherCodeRequired)
    }
  }, [currentLanguage])

  useEffect(() => {
    if (triggerValidation &&
      addedVouchers.length === 0 &&
      (hasInsufficientVoucherCodeError || Number(amountDue) > 0)) {
      setVoucherCodeErrorMessage(textContent?.shortTextFields?.voucherCodeRequired)
      voucherRequiredRef.current.scrollIntoView({
        behavior: "smooth"
      })
    }
  }, [triggerValidation])

  const handleVoucherFocus = () => {
    updatePaymentStore({ [PAYMENT_STATE.VOUCHER.INSUFFICIENT_AMOUNT_ERROR]: false })
    setVoucherCodeErrorMessage('')
  }

  return (
    <div>
      <div className="mb-4">
        <Typography variant={{ size: 'h4' }}>{textContent?.shortTextFields?.payWithVoucher}</Typography>
      </div>
      <div className="flex flex-col w-full space-y-4 lg:space-y-0 lg:space-x-4">
        <div className="w-full">
          <div className="flex flex-col md:flex-row md:flex-wrap w-full items-start gap-4 md:gap-6">
            <div ref={voucherRequiredRef} className="flex-1 w-full">
              <Input
                label={textContent?.shortTextFields?.voucherCodeTitle}
                id="voucherCode"
                value={voucherCode}
                onChange={handleVoucherCodeChange}
                validation={voucherCodeErrorMessage ? 'error' : undefined}
                onFocus={handleVoucherFocus}
                maxLength={12}
                testId="payment-voucherInput"
              />
              {/* Render the error with the same markup as the credit card fields
                  (14px danger Typography + icon) so the voucher error state matches
                  the rest of the payment form instead of the kit's default feedback. */}
              {voucherCodeErrorMessage && (
                <div className="flex items-center gap-2 mt-1 w-full px-4 py-3" style={{ backgroundColor: 'var(--color-error-light)' }}>
                  <Icon icon="ExclamationOctagon" className="h-4" variant={{ color: 'danger' }} />
                  <Typography variant={{ size: 'small', colour: 'danger' }}>{voucherCodeErrorMessage}</Typography>
                </div>
              )}
            </div>
            {addedVouchers.length > 0 && (
              <div className="w-full order-2 md:order-3">
                <div className="flex justify-between items-center my-3">
                  <Typography variant={{ size: 'small', bold: true }}>
                    {textContent?.shortTextFields?.voucherAddedTitle} {addedVouchers.length} &nbsp;
                    {`(${textContent?.shortTextFields?.voucherTotalOf || 'Total of'} ${currencyFormatter(voucherTotal, currentLanguage)})`}
                  </Typography>
                  <Button
                    onPress={() => setIsListExpanded(!isListExpanded)}
                    variant={{ text: true, size: 'small' }}
                    tokens={{ color: '#000000' }}
                    testId="payment-voucherToggle"
                  >
                    <Typography variant={{ size: 'small', bold: true }}>
                      {isListExpanded
                        ? textContent?.shortTextFields?.hide || 'Hide'
                        : textContent?.shortTextFields?.show || 'Show'}
                    </Typography>
                    <span
                      className={`flex transition-transform duration-300 ease-in-out ${isListExpanded ? 'rotate-180' : 'rotate-0'}`}
                    >
                      <Icon icon="ChevronDown" variant={{ size: 'small' }} />
                    </span>
                  </Button>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${isListExpanded ? 'max-h-96' : 'max-h-0'}`}
                >
                  <VoucherList
                    items={addedVouchers.map((v) => ({ id: v.id, amount: currencyFormatter(v.totalAmount, currentLanguage) }))}
                    onRemove={(id) => removePromo({ id })}
                    removeLabel={textContent?.shortTextFields?.remove}
                  />
                </div>
              </div>
            )}
            <div className="w-full md:w-auto shrink-0 order-3 md:order-2 md:self-end flex flex-col">
              <Button
                ref={voucherButtonRef}
                onPress={addVoucherCode}
                loading={isVoucherLoading}
                variant={{ width: 'full' }}
                tokens={{ backgroundColor: '#000000', color: '#ffffff', borderColor: '#000000' }}
                testId="payment-voucherButton"
              >
                {textContent?.shortTextFields?.add}
              </Button>
              {voucherCodeErrorMessage && <div className="h-12" aria-hidden="true" />}
            </div>
          </div>

          {addedVouchers &&
            addedVouchers.length > 0 &&
            (hasInsufficientVoucherCodeError || Number(amountDue) > 0) && (
              <div className="flex items-center space-y-2" data-testid="voucherRequired">
                <Icon icon="ExclamationOctagon" variant={{ color: 'danger' }} />
                <span className="ml-1">
                  <Typography variant={{ size: 'small', colour: 'danger' }}>{textContent?.shortTextFields?.insuffucientAmountMessage}</Typography>
                </span>
              </div>
            )}
        </div>

      </div>
      <div className="flex flex-col w-full my-6 space-y-4">
        <Input
          type="checkbox"
          label={`${textContent?.shortTextFields?.voucherMessageHeading || ''} ${textContent?.shortTextFields?.voucherMessageHeadingDetail || ''}`}
          checked={autoTopUps}
          onChange={handleRegisterPopup}
          disabled={isMultiPromoLoading}
          testId="payment-registerPopupCheck"
          boldCheckboxLabel
        />
        <Typography block variant={{ size: 'medium' }} >{textContent?.longTextFields?.voucherTopUpMessage}</Typography>
      </div>

      {autoTopUps && (
        <>
          <div className="my-4">
            <Divider />
          </div>
          <CreditCardSection
            textContent={textContent}
            paymentGateway={paymentGateway}
            handleSIMActivation={handleSIMActivation}
            showErrors={showErrors}
            setButtonIsLoading={setButtonIsLoading}
            voucherRequiredRef={voucherRequiredRef}
            // Travels with voucherRequiredRef above: EPSCard only scrolls to that
            // ref, and only refuses to tokenize, while this is true. Without it
            // EPSCard falls back to its `= false` default and lets the customer
            // activate with the voucher short of the total - the 911 fee being the
            // usual shortfall, since the voucher covers the plan but not the fee.
            hasInsufficientVoucherCodeError={hasInsufficientVoucherCodeError}
          />
        </>
      )}
    </div>
  )
}

export default VoucherOptionSection
